export const USER_API_ROUTES = {
  GET_TOPICS: '/users/customers/topic/:id',
  GET_FREE_TOPICS: '/users/customers/topic/free',
  GET_TOPIC_BY_ID: '/users/customers/subject/single/:id',
};
